/**
 * The different caption modes that can be used.
 *
 * @group CTA-608
 * @beta
 */
export type CaptionModes = 'MODE_ROLL-UP' |
	'MODE_POP-ON' |
	'MODE_PAINT-ON' |
	'MODE_TEXT' |
	null;
